import React from 'react'
import Testimonial from '../../component/Global/Testimonial'
function Testimonials() {
    return (
        <section className='testimonials mt-5'>
            <div className="container">
                <div className="content-header">
                    <p className="section-subtitle">
                        Our Customers Stories
                    </p>
                    <h1 className="testimonial-title section-title">
                        Read how
                        our customers
                        drive impact.
                    </h1>
                </div>
                <div className="testimonial-content">
                    <Testimonial />
                </div>
            </div>
        </section>
    )
}

export default Testimonials